import { Routes } from '@angular/router';

export const backendWidgetRouting: Routes = [
    {
        path: 'list',
        loadComponent: () => import('./page-widget-list/page-widget-list.component').then(m => m.PageWidgetListComponent),
    },
];

export const publicWidgetRouting: Routes = [
    {
        path: ':slug',
        loadComponent: () => import('./page-widget-view/page-widget-view.component').then(m => m.PageWidgetViewComponent),
    },
];
